module.exports = __webpack_public_path__ + "img/market64_ua.f096ef44.webp";